import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

const HalloweenCorner = ({ side }) => (
    <svg
        class={`halloween-decoration-corner halloween-decoration-${side}`}
        width='160'
        height='48'
        viewBox='0 0 160 48'
        aria-hidden='true'
        focusable='false'
    >
        <defs>
            <radialGradient id={`halloween-halo-${side}`}>
                <stop offset='0' stop-color='#ffad46' stop-opacity='.24' />
                <stop offset='1' stop-color='#e88425' stop-opacity='0' />
            </radialGradient>
            <linearGradient id={`halloween-pumpkin-${side}`} x1='0' y1='0' x2='0.8' y2='1'>
                <stop offset='0' stop-color='#eaa04d' />
                <stop offset='.5' stop-color='#ca6c28' />
                <stop offset='1' stop-color='#85411f' />
            </linearGradient>
        </defs>
        <ellipse cx='86' cy='22' rx='37' ry='26' fill={`url(#halloween-halo-${side})`} />
        {/* Fine strands stay at the outer edge, away from the centre logo. */}
        <path
            d={'M0 0 L62 0 M0 0 L58 13 M0 0 L43 27 M0 0 L23 39 M0 0 L0 47 '
                + 'M16 0 Q13 2 15 3 Q10 4 11 7 Q6 7 6 10 Q3 9 0 12 '
                + 'M32 0 Q27 4 29 7 Q21 8 22 14 Q13 14 12 20 Q6 19 0 24 '
                + 'M48 0 Q42 6 44 10 Q32 13 33 21 Q20 21 18 30 Q9 29 0 36 '
                + 'M62 0 Q56 7 58 13 Q42 17 43 27 Q26 28 23 39 Q11 38 0 47'}
            fill='none'
            stroke='#b7aaa0'
            stroke-opacity='.5'
            stroke-width='.8'
        />
        {/* A small hanging jack-o'-lantern, shaded without animation or blur filters. */}
        <path d='M86 0 V8' stroke='#aa8b68' stroke-opacity='.65' stroke-width='.8' />
        <path d='M85 12 Q83 6 89 6' fill='none' stroke='#82764c' stroke-width='2.5' />
        <path
            d='M86 12 C65 5 64 37 79 38 Q86 41 93 38 C108 37 107 5 86 12 Z'
            fill={`url(#halloween-pumpkin-${side})`}
            stroke='#a65d2e'
            stroke-width='.7'
        />
        <path
            d='M82 13 C75 18 76 31 81 36 M90 13 C97 18 96 31 91 36 M86 14 V36'
            fill='none'
            stroke='#713b24'
            stroke-opacity='.35'
            stroke-width='1'
        />
        <path
            d='M75 23 L80 18 L82 24 Z M90 24 L92 18 L97 23 Z M78 28 L83 30 L86 28 L89 30 L94 28 Q86 39 78 28 Z'
            fill='#ffd48a'
            stroke='#88431f'
            stroke-width='.6'
        />
        <path
            d={'M119 13 L122 9 L124 12 L126 9 L128 13 '
                + 'Q136 6 145 9 Q138 12 139 17 Q133 14 132 20 '
                + 'Q127 17 124 22 Q121 17 116 20 Q115 14 109 17 Q110 12 103 9 Q112 6 119 13 Z'}
            fill='#62576b'
            stroke='#aa96ad'
            stroke-opacity='.45'
            stroke-width='.6'
        />
    </svg>
);

@observer
class HalloweenDecoration extends Component {
    render() {
        const { appState, userStore } = this.props.stores;
        const { currentCustomer, opts = {} } = appState;
        const customer = opts.showDyrejournal ? userStore.customer : currentCustomer;

        if (parseInt(customer?.featureFlags?.halloweenDecoration, 10) !== 1) {
            return null;
        }

        return (
            <div
                aria-hidden='true'
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '48px',
                    pointerEvents: 'none',
                    overflow: 'hidden',
                    zIndex: 9999,
                }}
            >
                <HalloweenCorner side='left' />
                <HalloweenCorner side='right' />
                <style>{`
                    .halloween-decoration-corner {
                        position: absolute;
                        top: 0;
                        width: 160px;
                        height: 48px;
                    }
                    .halloween-decoration-left { left: 0; }
                    .halloween-decoration-right { right: 0; transform: scaleX(-1); }
                    @media (max-width: 600px) {
                        .halloween-decoration-corner { width: 100px; height: 30px; }
                    }
                `}</style>
            </div>
        );
    }
}

export default HalloweenDecoration;
